import { render } from "./ChatGroupMsg.vue?vue&type=template&id=75ae9ec3"
import script from "./ChatGroupMsg.vue?vue&type=script&lang=js"
export * from "./ChatGroupMsg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/chat/parts/ChatGroupMsg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75ae9ec3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75ae9ec3', __exports__)) {
    api.reload('75ae9ec3', __exports__)
  }
  
  module.hot.accept("./ChatGroupMsg.vue?vue&type=template&id=75ae9ec3", () => {
    api.rerender('75ae9ec3', render)
  })

}


export default __exports__